<template>
  <v-app>
    <Sidebar v-if="showMenu"/>
    <v-content>
      <!--<Alert v-bind:alert="alert_array"/>-->
      <FullPageLoader v-bind:full_page_load="full_page_load"/>
      <ServerError v-if="this.$store.state.server_error_show" :show_error="this.$store.state.server_error_show"></ServerError>
      <!--<v-container fluid>-->
      <Spinner v-if="this.$store.state.router_loading_show"></Spinner>
      
      <!--<transition name="fade">-->
        <router-view  v-if="!this.$store.state.router_loading_show"></router-view>
      <!--</transition>-->
      <!--</v-container>-->
    </v-content>
    <Footer  v-if="showFooter"></Footer>
  </v-app>
</template>

<script>
import Spinner from '@/components/Spinner'
import pSpinner from '@/components/pSpinner'
import ServerError from '@/components/ServerError'

import Sidebar from '@/components/Sidebar';
import FullPageLoader from '@/components/FullPageLoader';
import Footer from '@/components/Footer';
import global from '@/components/rbconstants';

//import Alert from '@/components/Alert';
import axios from 'axios'



export default {
  data: () => ({
    dialog: false,
    alert_array : {},
    full_page_load : false,
    showloading :true,
    
  }),
  components : {
    Sidebar : Sidebar,
    FullPageLoader : FullPageLoader,
    Spinner : Spinner,
    ServerError : ServerError,
    Footer : Footer,
    //Alert : Alert
  },
  computed: {
    
        showMenu() {
          return this.showloading == false && this.$route.path !== '/' && this.$route.path !== '/register' && this.$route.path !== '/otp/verification' && this.$route.path !== '/error'   && this.$route.name !== 'Error' && this.$route.name !== '403' && this.$route.name !== 'Servererror' && this.$route.name !== '401' && this.$route.name !== '404' && this.$route.name !== 'ChangePassword' && this.$route.name !== 'ForgotPassword' && this.$route.name !== 'ForgotPasswordUpdate';
          
        },
        showFooter() {
          return this.$route.path !== '/' && this.$route.name !== 'ChangePassword' && this.$route.name !== '403' && this.$route.name !== '404' && this.$route.name !== 'ForgotPassword' && this.$route.name !== 'ForgotPasswordUpdate';

        }
  
    },
    created : function (){
        
        this.is_valid_token()
        
    },
  methods: {
    // onAlertShow(value) {
    //   this.alert_array = value;
    // },
    
    is_valid_token : function () {
   
            var app = this
           
           app.showloading = false
            
           // app.showloading = true
 
            // axios.post(global.links.check_valid_token, {
                   
            //         headers : {
                    
            //             'Authorization' : 'Bearer '+localStorage.getItem('token'),
                        
            //             'Content-Type' : 'application/json'
                    
            //         }
            //     })
                
            //     .then(function(response) {
                    
            //         app.showloading = false
              
            //     })
                
            //     .catch(function(error) {
                    
            //         app.showloading = false
                   
            //         //common_error.error_response(error.response) 
                        
            //     })      
          
        },
  }
  
};
</script>
